import { useState } from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import axios from "axios";

export default function ResetUserModal({
  username,
  userId,
  handleClose,
  refreshUsers,
  email,
}) {
  const url = process.env.REACT_APP_URL;
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshUsers();
      }
    }, duration);
  };

  const handleUnblock = async () => {
    setDisable(true);
    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      userId: userId,
      username: username,
      email: email,
    };
    await axios
      .post(`${url}/users/unblock`, reqBody)
      .then((res) => {
        handleAlert("User successfully unblocked", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - please try again", "error");
      });
  };
  return (
    <Box className="reset-user-modal">
      <section className="reset-user-content">
        <h2>Reset User</h2>
        <p>Are you sure you want to unblock user?</p>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            No
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleUnblock}
            disabled={disable}
          >
            Yes
          </Button>
        </section>
      </section>
    </Box>
  );
}
